import React from 'react';
import type { Key } from '@adobe/react-spectrum';

import { ComboBox, ComboBoxItem } from '@/components/v2/Form/ComboBox/ComboBox';

type NewParentOrg = {
  id: string | undefined;
  name: string | undefined;
};

interface ParentOrgComboboxProps {
  newParentOrgs: NewParentOrg[] | undefined;
  selectedParentOrg: Key;
  setSelectedParentOrg: (value: React.SetStateAction<Key>) => void;
  sortedNewParentOrgs: NewParentOrg[] | undefined;
}

export const ParentOrgComboBox = ({
  newParentOrgs,
  selectedParentOrg,
  setSelectedParentOrg,
  sortedNewParentOrgs,
}: ParentOrgComboboxProps) => (
  <ComboBox
    testId="parent-org-combobox"
    defaultItems={newParentOrgs}
    label="Parent organization"
    selectedKey={selectedParentOrg}
    placeholder="Select parent organization"
    onSelectionChange={(key) => setSelectedParentOrg(key)}>
    {sortedNewParentOrgs?.map((org) => (
      <ComboBoxItem data-cy={`parent-org-combobox-item-${org.id}`} key={org?.id} id={org?.id}>
        {org?.name}
      </ComboBoxItem>
    ))}
  </ComboBox>
);
